import { DaysOfWeek } from "../../../constants";

export const getDayOfWeek = (day) => !day?.length ? '' : DaysOfWeek.find(({value}) => Number(value) === Number(day[0]))?.name;

export const getMaxLength = (type) => {
    switch (type) {
        case 'weekly': return 52;
        case 'monthly': return 12;
        default: return 0;
    }
}

export const getMaxCycles = (length, maxLength) => (length > 0 ? (maxLength / length) : 0);

export const convertHoursMinsToDec = (hours, mins) => (hours + (mins / 60));
export const convertDecToHoursMins = (dec) => {
    const hours = Math.trunc(dec);
    return {
        hours,
        minutes: Math.trunc((dec - hours) * 60)
    };
};